import handler from '../handler/handler'
import messages from '../handler/messages/upload-messages'

const statusHandler = handler(messages)

export default {
  state: {
    loading: false,
    fold: false,
  },
  mutations: {
    showLoading(state) {
      state.loading = true
    },

    hideLoading(state) {
      state.loading = false
    },

    folding(state) {
      state.fold = !state.fold
    },

    setFoldState(state, foldState) {
      state.fold = foldState
    },
  },
  actions: {
    imageUploadS3: async ({ commit, getters }, { name, image }) => {
      const config = { headers: { 'content-type': 'multipart/form-data' } }
      const formData = new FormData()
      formData.append('image', image)

      const result = await statusHandler.authPost({ commit, getters }, `/api/upload/${name}/image`, formData, config)
      return result
    },

    imagesUploadS3: async ({ commit, getters }, { name, images }) => {
      const config = { headers: { 'content-type': 'multipart/form-data' } }
      const formData = new FormData()

      images.forEach((image, index) => formData.append(`${index}`, image))

      const result = await statusHandler.authPost({ commit, getters }, `/api/upload/${name}/images`, formData, config)

      const tempArr = []

      images.forEach((image, index) => {
        Object.entries(result.response).forEach((item) => {
          if (tempArr.length <= index) {
            if (parseInt(item[0], 10) === index) {
              tempArr.push(item[1])
            }
          }
        })

        if (tempArr.length <= index) {
          tempArr.push(image)
        }
      })

      result.response = tempArr

      return result
    },
  },
  getters: {
    isLoadingState: state => state.loading,
    isFold: state => state.fold,
  },
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common.js